<template>
  <div class="section section-tramites-detalle">
    <div class="container">
      <h2></h2>
      <p>
        Renovamos nuestra página y ahora es posible efectuar trámites de autorizaciones, facturación y mucho más, estés donde estés.
        En tiempos en los que todo cambia muy rápido, nos adaptamos para darles la mejor respuesta posible. Por eso, para aquellos que prefieren los medios digitales incorporamos la sección Trámites on line: está disponible en la web desde la PC o el móvil.
      </p>
      <div id="tramites-detalle">
        <div class="row">
          <div class="col-md-12">
            <tabs pills type="primary">
              <tab-pane v-for="item in tramites" :key="item.id" :label="item.titulo" center>
                <p v-html="item.descripcion"></p>
              </tab-pane>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  components: {
    Card,
    Tabs,
    TabPane
  },
  data() {
    return {
      tramites: []
    };
  },
  mounted() {
    this.$zaiq()
      .get("Tramite/GetAll")
      .then(response => {
       // console.log(response.data.result.items);
        this.tramites = response.data.result.items;
      });
  }
};
</script>
<style scoped>
div.section {
  padding: 0px 0;
}
</style>

